/* @flow */
import * as React from 'react';
import idx from 'idx';
import { graphql, compose } from 'react-apollo';

import AdminUpgradePageView from 'admin/components/AdminUpgradePageView';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import ORGANIZATION_QUOTE_QUERY from 'admin/queries/OrganizationQuoteQuery.gql';

import type { OrganizationQuote } from 'admin/queries/__generated__/OrganizationQuote';

type Props = {
  organizationUuid: ?string,
  data: ReactApolloData<OrganizationQuote>,
};

const AdminUpgradePage = function(props: Props) {
  const { organizationUuid, data } = props;
  const loading = idx(data, _ => _.loading);
  const quote = idx(data, _ => _.organizations[0].quoteRequestedByUser);

  return loading ? (
    <CenteredLoadingIndicator data-test="loading" />
  ) : (
    <AdminUpgradePageView organizationUuid={organizationUuid} quote={quote} />
  );
};

const withData = graphql(ORGANIZATION_QUOTE_QUERY, {
  skip: ({ organizationUuid }) => !organizationUuid,
  options: ({ organizationUuid }) => ({
    variables: {
      organizationUuid,
    },
    fetchPolicy: 'network-only',
  }),
});

export { AdminUpgradePage };
export default compose(withData)(AdminUpgradePage);
